module.exports = __webpack_public_path__ + "img/Zeppa_SX.78944874.png";